import React from "react";

interface FormFieldProps {
  id: string;
  label: string;
  type?: "text" | "email" | "password" | "tel" | "date";
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  name?: string;
  autoComplete?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  className?: string;
  inputClassName?: string;
  testId?: string;
}

export function FormField({
  id,
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  error,
  required = false,
  disabled = false,
  name,
  autoComplete,
  inputMode,
  className = "",
  inputClassName = "",
  testId,
}: FormFieldProps) {
  return (
    <div className={className}>
      <label
        htmlFor={id}
        className="block mb-2 text-sm font-medium text-black required-label"
        style={{ fontFamily: "TT Commons Pro" }}
      >
        {label}
      </label>
      <input
        id={id}
        type={type}
        name={name || id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        autoComplete={autoComplete}
        inputMode={inputMode}
        className={`w-full !border-0 ring-1 ring-inset rounded-lg px-4 !py-[10.5px] leading-6 text-[16px] bg-white text-[#353535] placeholder:text-[#676767] ${
          error ? "ring-[#E34D52]" : "ring-gray-300"
        } ${inputClassName}`}
        placeholder={placeholder}
        aria-required={required}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
        data-testid={testId}
      />
      {error && (
        <p
          id={`${id}-error`}
          className="text-[#E34D52] text-sm mt-2"
          style={{ fontFamily: "TT Commons Pro" }}
          role="alert"
          aria-live="assertive"
        >
          {error}
        </p>
      )}
    </div>
  );
}
